import axios from "@/utils/request"

// 产品列表
export function getReport() {
  return axios({
    url: "/distribution/userStudent",
    method: "GET"
  })
}

export function postReport(data) {
  return axios({
    url: "/distribution/userStudent",
    method: "POST",
    data
  })
}

export function getInfo() {
  return axios({
    url: "/distribution/user",
    method: "get",
    headers: {
      "Content-Type": "application/json;charset=UTF-8"
    }
  })
}
